import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { TimelineMax, TweenMax } from 'gsap';
import styles from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';
import { useLang } from '@/i18n';

const { EFPic } = createEFPic('/media/ecocredits-day/h5/');

export default function FirstKv() {
    const { locale } = useRouter();
    const { t } = useLang('ecocreditsday.firstKv');
    const kvMap = { jp: 'kv' };
    const kvName = kvMap[locale as keyof typeof kvMap] || kvMap.jp;
    const [showAni, setShowAni] = useState(false);

    useEffect(() => {
        setShowAni(true);
        const scene = new ScrollMagic.Scene({
            triggerElement: '.firstKv',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 400,
        });
        const timeline = new TimelineMax();
        const tweenA1 = TweenMax.to('.kv-box', 0.5, { top: '-60px' });
        const tweenA2 = TweenMax.to('.opacity-box', 0.8, { opacity: 0 });
        timeline.add(tweenA1, 0).add(tweenA2, 0.4);

        scene.setTween(timeline);
        controllerDay.addScene(scene);

        return () => {
            scene && scene?.destroy();
        };
    }, []);

    return (
        <div className={`${styles.firstKv} kv-container`}>
            <div className="opacity-box">
                <div className={`kv-box ${showAni ? 'animate-bg' : ''}`}>
                    <EFPic className={`bg-img ${showAni ? 'animate-img' : ''}`} name={[`${kvName}.webp`, `${kvName}.jpg`]} />
                </div>
            </div>
            <div className="show-box">
                <div className="translate-box">
                    <div className={`content-box ${showAni ? 'kv-animate' : ''} kv-text__box`}>
                        <div className="title">{t('title')}</div>
                        <div className="desc">{t('desc')}</div>
                        <div className="tip">{t('tip')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
